import script from "./ScriptError.vue?vue&type=script&setup=true&lang=js"
export * from "./ScriptError.vue?vue&type=script&setup=true&lang=js"

import "./ScriptError.vue?vue&type=style&index=0&id=790d329b&scoped=true&lang=scss"

import exportComponent from "D:\\DongLK\\Project\\ytbot\\controller-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790d329b"]])

export default __exports__